<template>
  <div>
    <hero-steps :type="'hotel'"></hero-steps>

    <!-- Complete Registration -->
    <div class="container">
      <complete-registration class="col-xs-12"></complete-registration>
    </div>
    <!-- // Complete Registration -->

    <div class="container min-height _mb-20">
      <div class="col-sm-12 mb-10 clearfix">
        <details-breadcrumb
          :go-back="'Hotéis'"
          :current="hotel.name">
          <template slot:default>
            <ul
              v-if="stars > 0"
              class="theme-search-results-item-hotel-stars pull-left">
              <li v-for="star in stars" :key="`star-${star}`">
                <i class="fa fa-star"></i>
              </li>
            </ul>
            <p
              v-if="fare"
              class="pull-left h5 _mt-0 _mb-0">
              <span class="weight-normal">à partir de</span>&nbsp;
              <strong class="h4">{{ fare | brlPrice }}</strong>
              <span>/noite</span>
            </p>
          </template>
        </details-breadcrumb>
      </div>

      <div class="col-xs-12 col-sm-9 _pb-40">
        <!-- Tabs Group -->
        <tabs-group :selected="'Photos'">
          <template v-slot:triggers="{ active, handleSelected }">
            <detail-tabs
              :active="active"
              @handleSelected="handleSelected"></detail-tabs>
          </template>
          <template v-slot:content="{ active }">
            <div
              v-if="active"
              class="_pt-15 _pb-15 clearfix" role="list">
              <detail-photos
                v-if="active === 'Photos'"
                :images="hotel.images"></detail-photos>
              <detail-info
                v-if="active === 'Info'"
                :policies="policies"></detail-info>
              <detail-map
                v-if="active === 'Map'"
                :google-iframe="googleIframe"></detail-map>
            </div>
          </template>
        </tabs-group>
        <!-- // Tabs Group -->

        <div
          v-if="Object.keys(params).length"
          class="row">

          <!-- Alert Warning -->
          <div
            id="hotel-details-error"
            class="col-xs-12 clearfix">
            <alert-helper
              :alert="error"
              :type="'danger'"
              :close="true">
            </alert-helper>
          </div>
          <!-- // Alert Warning -->

          <div class="col-xs-12 col-md-5 _mt-5">
            <div class="col-xs-6 size-18 _mb-0 _pr-0 _pl-0">
              <div class="color-gray-light-mid weight-lighter">
                <i class="fa fa-calendar"></i>
                Check In:
              </div>
              <p class="_mb-0">{{ params.date_start | dateToWeekday }}</p>
            </div>
            <div class="col-xs-6 size-18 _mb-0 _pr-0 _pl-0">
              <div class="color-gray-light-mid weight-lighter">
                <i class="fa fa-calendar"></i>
                Check Out:
              </div>
              <p class="_mb-0">{{ params.date_end | dateToWeekday }}</p>
            </div>
            <div class="col-xs-12 _pr-0 _pl-0">
              <p class="size-14 _mb-0">
                {{ params.rooms }} {{ 'quarto' | pluralize(params.rooms) }},
                {{ params.adults }} {{ 'adulto' | pluralize(params.adults) }},
                {{ params.nights }} {{ 'noite' | pluralize(params.nights) }}
              </p>
            </div>
          </div>

          <div
            id="hotel-details-select-traveler"
            class="col-xs-12 col-md-7 _mt-10">
            <form class="row">
              <div :class="{ 'alert alert-danger pa-10': submitted && !hasValidTravelers }">
              <i
                :class="[{ 'fa-users':  this.params.adults > 1}, { 'fa-user':  this.params.adults === 1}]"
                class="fa"></i>
              <template v-if="submitted && !hasValidTravelers">
                {{ 'Selecione os viajantes' | pluralize(this.params.adults) }}:
              </template>
              <template v-else>
                {{ 'Viajantes' | pluralize(this.params.adults) }}:
              </template>
              {{ this.params.adults }} {{ 'adultos' | pluralize(this.params.adults) }}
            </div>

            <!-- Alert Warning -->
            <div
              id="hotel-details-error"
              class="_mb-10 _mt-10">
              <alert-helper
                :alert="error"
                :type="'danger'"
                :close="true">
              </alert-helper>
            </div>
            <!-- // Alert Warning -->

            <div class="col-sm-12 col-xs-12 _pb-20 clearfix">
              <!-- Multiselect Travelers -->
              <multiselect-travelers
                :travelers.sync="travelers"
                :error="submitted && !hasValidTravelers"
                :max="this.params.adults"></multiselect-travelers>
              <!-- // Multiselect Travelers -->
            </div>
            </form>
          </div>
        </div>

        <!-- Rooms List -->
        <rooms-list
          @handleReserve="handleReserve"
          :rooms="rooms"
          :provider="provider"></rooms-list>
        <!-- // Rooms List -->
      </div>

      <div class="col-xs-12 col-sm-3">
        <!-- Propaganda -->
        <div class="theme-ad">
          <a class="theme-ad-link" href="#"></a>
          <p class="theme-ad-sign">Propaganda</p>
          <img
            class="theme-ad-img"
            src="@/assets/img/banner_anuncio_gol.jpg"
            alt="Image Alternative text"
            title="Image Title" />
        </div>
        <!-- Propaganda -->
      </div>
    </div>

    <lockscreen :loading="loadingHotel || loadingReserve"></lockscreen>
  </div>
</template>

<script>
import _ from 'underscore';
import { mapActions, mapState } from 'vuex';
import HeroSteps from '@/components/template/HeroSteps';
import CompleteRegistration from '@/components/dialogs/CompleteRegistration';
import DetailsBreadcrumb from '@/components/template/DetailsBreadcrumb';
import AlertHelper from '@/components/ui/AlertHelper';
import TabsGroup from '@/components/ui/TabsGroup';
import DetailTabs from '@/views/hotel/details/DetailTabs';
import DetailPhotos from '@/views/hotel/details/DetailPhotos';
import DetailInfo from '@/views/hotel/details/DetailInfo';
import DetailMap from '@/views/hotel/details/DetailMap';
import RoomsList from '@/views/hotel/details/RoomsList';
import lockscreen from '@/components/lockscreen/index.vue';
import scrollToElement from '@/mixins/scrollToElement';
import { dateToWeekday } from '@/filters/datetime'
import MultiselectTravelers from "@/components/fields/MultiselectTravelers.vue";
import {axiosUpdateHeaders} from "@/http";

export default {
  filters: { dateToWeekday },
  mixins: [ scrollToElement ],
  components: {
    MultiselectTravelers,
    HeroSteps,
    CompleteRegistration,
    DetailsBreadcrumb,
    AlertHelper,
    TabsGroup,
    DetailTabs,
    DetailPhotos,
    DetailInfo,
    DetailMap,
    RoomsList,
    lockscreen
  },
  data () {
    return {
      rooms: [],
      policies: {},
      hotel: {},
      googleIframe: '',
      search: {},
      params: {},
      provider: {
        config: {
          fareField: null
        }
      },
      travelers: [],
      hasValidTravelers: false,
      submitted: false,
      error: null
    }
  },
  mounted () {
    this.getHotel(this.$route.params.hash)
      .then(this.setHotel)
      .catch(this.setError);
  },
  computed: {
    ...mapState('hotels', {
      'loadingHotel': state => state.loading
    }),
    ...mapState('reserve', {
      'loadingReserve': state => state.loading
    }),
    stars () {
      if (!this.hotel.hasOwnProperty('awards')) return 0;
      const star = _.findWhere(this.hotel.awards, { slug: 'star' });
      return (star) ? parseInt(star.rate) : 0;
    },
    fare () {
      return this.search[this.provider.config.fareField]
    }
  },
    watch: {
    travelers (data) {
      if (data) this.validateTravelers()
    }
  },
  methods: {
    ...mapActions('hotels', ['getHotel']),
    ...mapActions('reserve', ['postReserve']),
    setHotel (data) {
      const search_data = data.search_data;
      this.hotel = search_data.search.hotel;
      this.provider = data.provider;
      this.policies = search_data.policies;
      this.rooms = search_data.rooms;
      this.search = _.omit(search_data.search, ['hotel', 'policies']);
      this.params = search_data.params;
      this.googleIframe = `https://maps.google.com/maps?q=${this.hotel.address}&t=&z=13&ie=UTF8&iwloc=&output=embed`;
    },
    setError() {
      this.$swal({
        title: "Não foi possível carregar os detalhes do hotel.\nClique em OK para fazer uma nova busca.",
        type: 'error',
        showConfirmButton: true,
      }).then(() => {
        this.$router.go(-1);
      });
    },
    validateTravelers () {
      const travelers = this.travelers
      this.hasValidTravelers = travelers.length === this.params.adults
    },
  async handleReserve (room) {
    this.submitted = true;
    this.error = null;

    if (!this.hasValidTravelers) {
      this.scrollToElement('hotel-details-error');
      return;
    }

    try {
      const hash = this.$route.params.hash;
      const axios = axiosUpdateHeaders();

      // 1. Faz segunda chamada com roomId
      const response = await axios.get(`/api/hotel/details/${hash}?roomId=${room.id}`);
      const updatedData = response.data;

      // 2. Reutiliza setHotel para atualizar tudo
      this.setHotel(updatedData);

      // 3. Usa os dados atualizados no postReserve
      await this.postReserve({
        search_data: this.search,
        hotel_data: this.hotel,
        room_data: updatedData.search_data.rooms[0],
        price_data: updatedData.search_data.rooms[0].prices[0],
        travelers: this.travelers,
        policies: this.policies
      });

      this.$router.push('/travel');

    } catch (error) {
      this.submitted = false;
      this.error = 'Não foi possível salvar sua reserva.';
      this.scrollToElement('hotel-details-error');
    }
}


  }
};
</script>
